import React, { useEffect, useRef, useState } from "react";
import FAQ from "../Components/FAQ";
import AboutWhychooseus from "../Components/AboutWhychooseus";
// import Aboutherobanner from "../Components/Aboutherobanner";
import CommitteeMembers from "../Components/CommitteeMembers";
import AboutHistory from "../Components/AboutHistory";
import Aboutgetconnected from "../Components/Aboutgetconnected";
import AboutsPageSkeleton from "../Components/Skeleton/AboutsPageSkeleton";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";


function Aboutuspage() {
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();

  
  const historyRef = useRef(null);
  const committeeMembersRef = useRef(null);
  const whyChooseUsRef = useRef(null);
  const getConnectedRef = useRef(null);
  const faqRef = useRef(null);

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    if (!isLoading) {
      const hash = location.hash;
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 0); 
      }
    }
  }, [location, isLoading]);

  if (isLoading) {
    return <AboutsPageSkeleton />;
  }
  return (
    <>
     <Helmet>
        <title>About Us - Learn About Our History and Team | St Johns College Jaffna</title>
        
        {/* SEO Meta Tags */}
        <meta
          name="description"
          content="Discover the rich history and dedicated committee members of St Johns College Jaffna. Learn why you should choose us, connect with our community, and explore our FAQs."
        />
        <meta
          name="keywords"
          content="St Johns College Jaffna, About Us, club history, committee members, why choose us, get connected, FAQs"
        />
        <meta name="robots" content="index, follow" />

       
        <meta property="og:title" content="About St Johns College Jaffna - History, Team, and Community" />
        <meta
          property="og:description"
          content="Get to know St Johns College Jaffna – from our rich history to our committee members and why you should choose us. Explore how we connect with our community."
        />
        <meta property="og:url" content="https://stjohns.microwe.net/aboutus" />
        <meta property="og:image" content="https://stjohns.microwe.net/images/og-about-us.jpg" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us - St Johns College Jaffna" />
        <meta name="twitter:description" content="Learn more about St Johns College Jaffna, our history, and why you should choose us." />
        <meta name="twitter:image" content="https://stjohns.microwe.net/images/og-about-us.jpg" />

        <meta charSet="utf-8" />
        <link rel="canonical" href="https://stjohns.microwe.net/aboutus" />
      </Helmet>

      {/* <div  >
        <Aboutherobanner />
      </div> */}
<div className="bg-header-gradient h-[144px] z-10 "></div>
      <div ref={historyRef} id="history">
        <AboutHistory  />
      </div>

      <div ref={committeeMembersRef} id="committeeMembers">
        <CommitteeMembers />
      </div>

      {/* <div ref={whyChooseUsRef} id="whyChooseUs">
        <AboutWhychooseus  />
      </div> */}
      <div ref={getConnectedRef} id="getConnected">
        <Aboutgetconnected />
      </div>
      <div ref={faqRef} id="faq" className="h-full pb-[150px]">
        <FAQ />
      </div>
    </>
  );
}

export default Aboutuspage;
